import Controller from '@ember/controller';
import { type Registry as Services, service } from '@ember/service';

export default class HotelSettingsCompetitorsIndexController extends Controller {
  @service declare access: Services['access'];
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasAnyCompsetBenchmark() {
    return (
      this.access.hasCompsetBenchmark ||
      this.access.hasSettingsBenchmarkPortfolioCompsetView ||
      this.hasBenchmarkSmartCompset
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasBenchmarkSmartCompset() {
    return this.access.hasCompsetBenchmarkSmartCompset;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get otherProductsTitle() {
    const products = [
      {
        check: this.access.hasRates,
        name: this.intl.t('general.rate_insight'),
      },
      {
        check: this.access.hasMarketInsight,
        name: this.intl.t('general.market_insight'),
      },
      {
        check: this.access.hasPricingAssistantTab,
        name: this.intl.t('general.pricing_assistant'),
      },
    ];

    return products
      .filter((product) => product.check)
      .map((product) => product.name)
      .join(', ');
  }
}
